import React, { useState, ChangeEvent, useEffect } from "react";
import {
  Container,
  Form,
  Button,
  ProgressBar,
  Image,
  Row,
  Col,
} from "react-bootstrap";
import Section from "../../Components/Section/Section";
import { getStyles } from "./BankDetails.style";
import { toast } from "react-toastify";
import {
  GET_BANK_DETAILS,
  Store_BankDetails,
  categories,
} from "../../Api";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import StepAccount from "../../assets/images/stepAccount.png";
import StepStore from "../../assets/images/stepStore.png";
import { STORAGE_CONSTANTS } from "../../shared/Constants/Constants";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { base_url } from "../../Api/ApiConst";

interface FormData {
  businessName: string;
  ownerName: string;
  businessType: string;
  address: string;
  city: string;
  pinCode: string;
  registrationNumber: string;
  email: string;
}

  

const BankDetails: React.FC = () => {
  const { t, i18n } = useTranslation();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const styles = getStyles(isMobile);
  const [step, setStep] = useState(2);
  interface Category {
    id: string;
    name: string;
    store_name: string;
    email: string;
    contact_number: any;
  }
  const [showModal, setShowModal] = useState(false);

  const [storeError, setStoreError] = useState<{
    cheque_copy?: string;
    // email?: string;
    // contact_number?: string;
    // store_type?: string;
  }>({});
  const [contactNumber, setContactNumber] = useState<any>("");
  const [mainCategory, setMainCategory] = React.useState<Category[]>([]);
  const [userToken, setUserToken] = useState<string | null>("");
  const navigate = useNavigate();
  const [idNumber, setIdNumber] = useState<any>("");
  const [idNumber2, setIdNumber2] = useState<any>("");
  const [bankData, setBankData] = useState<any>("");
  const [idNumber1File, setIdNumber1File] = useState<File | null>(null);
  const [idNumber2File, setIdNumber2File] = useState<File | null>(null);
  const [chequeFile, setChequeFile] = useState<any>("");
  const [prevChequeFile, setPrevChequeFile] = useState<any>("");
  const [error, setError] = useState({
    cheque: "",
  });

  const schema = yup.object().shape({
    branch: yup.string().required(t("responseMessage.branchNameRequired")),
    areaPinCode: yup
      .string()
      .required("* Enter your pincode")
      .matches(/^(?:[0-9\s,]*\d){1,6}$/, "Invalid pincode"),
    accountNumber: yup
      .string()
      .required(t("responseMessage.enterAccountNumber"))
      .matches(/^[0-9]+$/, t("responseMessage.onlyDigits")),

    bank: yup.string().required(t("responseMessage.accountName")),
    accountHolderName: yup.string().required(t("responseMessage.accountName")),
  });

  const {
    register,
    formState: { errors },
    control,
    reset,
    handleSubmit,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const fetchCategories = async () => {
    try {
      const response = await categories();
      if (response && response.status === 200) {
        setMainCategory(response.data);
      } else {
        console.log("Error fetching categories");
      }
    } catch (error) {
      console.log("Error fetching categories", error);
    }
  };

  useEffect(() => {
    setContactNumber(localStorage.getItem(STORAGE_CONSTANTS.USER_NUMBER));
    setUserToken(localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN));
    const pincode = localStorage.getItem(STORAGE_CONSTANTS.AREA_PIN);
    reset({
      areaPinCode: pincode ?? "",
    });
    fetchCategories();
    BankDetails();
    // fetchFile()
    window.scrollTo(0, 0);
  }, []);

  const BankDetails = async () => {
    try {
      const response = await GET_BANK_DETAILS(userToken);
      if (response && response.status === 200) {
        const data = response.data.bank_details;
        setBankData(data);
        setIdNumber(data.id_document_1);
        setIdNumber2(data.id_document_2);
        if(data.cheque_copy){
          fetchFile(data.cheque_copy)
        }


        reset({
          accountNumber: data.account_number ?? "",
          bank: data.bank_name ?? "",
          accountHolderName: data.account_name ?? "",
          branch: data.country ?? "",
        });
      } else {
        console.log("Error fetching set-store details");
      }
    } catch (error) {
      console.log("Error fetching set-store details", error);
    }
  };

  const fetchFile = async (ele:any) => {
    try {
     const response = await fetch(`${base_url}${ele}`);
     const blob = await response.blob();
     const fileName = 'React_Js_Documentation.docx';
     const file = new File([blob], fileName, {
        type: blob.type,
        lastModified: Date.now() // Set last modified to the current timestamp
     });
     setPrevChequeFile(file);
    } catch (error) {
     console.error('Error fetching file:', error);
    }
};

  const [selectedOption, setSelectedOption] = useState<string>("");

  const handleOptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedOption(e.target.value);
  };

  // Function to open modal
  const handleOpenModal = () => {
    setShowModal(true);
  };

  // Function to close modal
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleFile1Change = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];
    if (file) {
      setIdNumber1File(file);
    }
  };

  const handleFile2Change = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];
    if (file) {
      setIdNumber2File(file);
    }
  };

  const handleFileCheque = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];
    if (file) {
      setChequeFile(file);
    }
  };

  const handleClick = async (data: any) => {
    // Check if chequeFile is empty
    if (!chequeFile && !prevChequeFile) {
      setError((error) => ({
        ...error,
        cheque: "* Upload your cheque copy",
      }));
      return; // Stop execution if neither a new file nor a previous file is provided
    }
    if (data) {
      try {
        const response = await Store_BankDetails(
          data,
          userToken,
          idNumber,
          idNumber2,
          chequeFile,
          idNumber1File,
          idNumber2File,
          prevChequeFile
        );

        if (response && response.status === 200) {
          toast.success(response["data"]["message"]);
          navigate("/profile");
        } else {
          toast.error(response["data"]["message"]);
        }
      } catch (error: any) {
        // Optionally, set an error state here if needed
        setStoreError(error.response.data.error);
      }
    }
};

  return (
    <Section
      className="storeRegistration"
      style={{ backgroundColor: "#F0F6FF", paddingTop: 50 }}
    >
      <Container className="mb-5">
        <h2 style={styles.mainTitle}>{t("storeRegister.pageTitle")}</h2>
        <ProgressBar now={(step / 2) * 100} label={`Step ${step} of 2`} />
        <div style={styles.step}>
          <div style={styles.stepWrap}>
            <div
              style={{
                backgroundColor: step === 1 ? "#075CF6" : "#075CF6",
                ...styles.stepBgWrap,
              }}
            >
              <Image src={StepStore} style={styles.stepIcon} />
            </div>
            <h3 style={styles.stepTitle}>{t("storeRegister.stepOne")}</h3>
          </div>
          <div style={styles.stepWrap}>
            <div
              style={{
                backgroundColor: step === 2 ? "#075CF6" : "#AED5FF",
                ...styles.stepBgWrap,
              }}
            >
              <Image src={StepAccount} style={styles.stepIcon} />
            </div>
            <h3 style={styles.stepTitle}>{t("storeRegister.stepTwo")}</h3>
          </div>
        </div>
      </Container>
      <div style={styles.whiteWrap}>
        <Container>
          {step === 2 && (
            <>
              <Form>
                <Form.Group controlId="idNumber">
                  <Form.Label>{t("storeRegister.idNumber")} 1</Form.Label>
                  <Form.Control
                    type="text"
                    value={idNumber}
                    onChange={(e) => setIdNumber(e.target.value)}
                  />

                </Form.Group>

                <Row className="align-items-center xs-row-wrap">
                  {bankData.id_document_1_file && (
                    <Col sm={1}>
                      <a
                        href={`${base_url}${bankData.id_document_1_file}`}
                        className="fileDownloadIconWrap"
                      >
                        <FontAwesomeIcon
                          icon={faDownload as any}
                          className="fileDownloadIcon"
                        />{" "}
                        Download
                      </a>
                    </Col>
                  )}
                  <Col sm={bankData.id_document_1_file ? 11 : 12}>
                    <Form.Group controlId="idNumber1File">
                      <Form.Label>
                        {t("storeRegister.idNumber")} 1 File
                      </Form.Label>
                      <Form.Control
                        type="file"
                        accept=".pdf,.doc,.docx"
                        onChange={handleFile1Change}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group controlId="idNumber2">
                  <Form.Label>{t("storeRegister.idNumberTwo")}</Form.Label>
                  <Form.Control
                    type="text"
                    value={idNumber2}
                    onChange={(e) => setIdNumber2(e.target.value)}
                  />        
                </Form.Group>
                <Row className="align-items-center xs-row-wrap">
                 
                  <Col sm={bankData.id_document_2_file ? 11 : 12}>
                    <Form.Group controlId="idNumber2File">
                      <Form.Label>
                        {t("storeRegister.idNumberTwo")} File
                      </Form.Label>
                      <Form.Control
                        type="file"
                        accept=".pdf,.doc,.docx"
                        onChange={handleFile2Change}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Group controlId="areaPinCode">
                  <Form.Label>{t("storeRegister.pinCodeService")}*</Form.Label>
                  <Form.Control
                    type="text"
                    {...register("areaPinCode")}
                  />
                 
                  {errors.areaPinCode && (
                    <span style={styles.error}>
                      {errors.areaPinCode.message}
                    </span>
                  )}{" "}
                </Form.Group>
                <Form.Group controlId="accountHolderName">
                  <Form.Label>
                    {t("storeRegister.accountHolderName")}*
                  </Form.Label>
                  <Form.Control
                    type="text"
                    {...register("accountHolderName")}
                  />
                  {errors.accountHolderName && (
                    <span style={styles.error}>
                      {errors.accountHolderName.message}
                    </span>
                  )}
                </Form.Group>
                <Form.Group controlId="bank">
                  <Form.Label>{"Bank Name"}*</Form.Label>
                  <Form.Control
                    type="text"
                    {...register("bank")}
                  />
                  {errors.bank && (
                    <span style={styles.error}>
                      {errors.bank.message}
                    </span>
                  )}
                </Form.Group>
                <Form.Group controlId="accountNumber">
                  <Form.Label>{t("storeRegister.accountNumber")}*</Form.Label>
                  <Form.Control
                    type="text"
                    {...register("accountNumber")}
                  />
                  {errors.accountNumber && (
                    <span style={styles.error}>
                      {errors.accountNumber.message}
                    </span>
                  )}
                </Form.Group>
               <Row className="align-items-center xs-row-wrap">
               {bankData.cheque_copy && (
                    <Col sm={1}>
                      <a
                        href={`${base_url}${bankData.cheque_copy}`}
                        className="fileDownloadIconWrap"
                      >
                        <FontAwesomeIcon
                          icon={faDownload as any}
                          className="fileDownloadIcon"
                        />{" "}
                        Download
                      </a>
                    </Col>
                  )}

               <Col sm={bankData.cheque_copy ? 11 : 12}>
               <Form.Group controlId="ifscCode">
                  <Form.Label>{"Cheque Copy/Scan"}*</Form.Label>
                  <Form.Control
                      type="file"
                      accept=".pdf,.doc,.docx"
                      onChange={handleFileCheque}
                    />
                  {error.cheque && (
                    <span style={styles.error}>{error.cheque}</span>
                  )}
                   {storeError.cheque_copy && (
                    <span style={styles.error}>{storeError.cheque_copy}</span>
                  )}
                </Form.Group>
               </Col>
               </Row>

                <Form.Group controlId="branch">
                  <Form.Label>{t("storeRegister.branch")}*</Form.Label>
                  <Form.Control
                    type="text"
                    {...register("branch")}
                  />
                  {errors.branch && (
                    <span style={styles.error}>{errors.branch.message}</span>
                  )}
                </Form.Group>
                <div className="align-items-center justify-content-center d-flex">
                  {/* Step 2 fields */}
                  <Button
                    variant="primary"
                    className="btnBlue submit"
                    onClick={handleSubmit(handleClick)}
                  >
                    {t("commonFormLabels.submit")}
                  </Button>
                </div>
              </Form>
            </>
          )}
        </Container>
      </div>
    </Section>
  );
};

export default BankDetails;
